import React from 'react';

export const Badge = ({ children, variant = 'default', className, ...props }) => {
  const variantClasses = {
    default: 'bg-azul-lago text-blanco-nieve',          // Azul Lago como fondo y Blanco Nieve para el texto
    secondary: 'bg-gris-pizarra text-blanco-nieve',    // Gris Pizarra como fondo y Blanco Nieve para el texto
    destructive: 'bg-red-500 text-white',              // Rojo como fondo y blanco para el texto (puedes ajustar el rojo)
    outline: 'border border-azul-lago text-azul-lago',  // Borde Azul Lago y texto Azul Lago
  };

  return (
    <span className={`badge ${variantClasses[variant]} ${className}`} {...props}>
      {children}
    </span>
  );
};
